import { useMessage } from "@/components/Message";

interface InputSelectButtonProps {
  clearSelection: () => void;
  getToggleButtonProps: any;
  isOpen: boolean;
  isClearable: boolean;
  disabled?: boolean;
}

export const InputSelectButtonComponent = ({
  clearSelection,
  disabled,
  getToggleButtonProps,
  isOpen,
  isClearable,
}: InputSelectButtonProps) => {
  const { msg } = useMessage();
  const {
    onClick: onClickToggleButton,
    "aria-haspopup": ariaHaspopup,
    "data-toggle": dataToggle,
    onKeyUp,
    onKeyDown,
    onBlur,
  } = getToggleButtonProps();

  const ariaLabel = isClearable ? msg({ id: "clearAndOpenMenu" }) : msg({ id: "openMenu" });

  return (
    <button
      aria-label={ariaLabel}
      aria-haspopup={ariaHaspopup}
      data-toggle={dataToggle}
      onKeyUp={onKeyUp}
      onKeyDown={onKeyDown}
      onBlur={onBlur}
      className="sid-input-select-button"
      disabled={disabled}
      type="button"
      onClick={(event) => {
        if (typeof clearSelection === "function") clearSelection();
        if (typeof onClickToggleButton === "function") onClickToggleButton(event);
      }}
    >
      <svg
        viewBox="0 0 20 20"
        preserveAspectRatio="none"
        width={16}
        fill="transparent"
        stroke="#8E95A4"
        strokeWidth="1.1px"
        transform={isOpen ? "rotate(180)" : undefined}
      >
        <path d="M1,6 L10,15 L19,6" />
      </svg>
    </button>
  );
};
